import { primaryColor, secondaryColor } from './colors';

export const palette = {
    primary: {
      main: primaryColor,
    },
    secondary: {
      main: secondaryColor,
    },
    text: {
      primary: '#333333',
      secondary: '#555555',
    },
  }